import React from "react";
import { Button } from "react-bootstrap";

export const Tags = props => {
  return props.title || props.src ? (
    <Button className={props.classes}>
      {props.src ? <img src={props.src} alt="" /> : null}
      {props.title ? <span>{props.title}</span> : null}
    </Button>
  ) : null;
};
